export const EventType = {
  AUTH: "AUTH",
  REGISTER_APP: "REGISTER_APP",
  REGISTER_MENU: "REGISTER_MENU",
  AUTH_USER: "AUTH_USER",
};